import { render, staticRenderFns } from "./AttachmentImageComponent.vue?vue&type=template&id=79de7f1e&scoped=true&"
import script from "./AttachmentImageComponent.vue?vue&type=script&lang=ts&"
export * from "./AttachmentImageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentImageComponent.vue?vue&type=style&index=0&id=79de7f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de7f1e",
  null
  
)

export default component.exports